import { getEnvironment, UserProfile } from '@sunrun/sales-experience-shared';
import { isFieldOrAIRHelper, isStreetOrFusionHelper } from './repTypeHelper';

/** Canonical Recheck URLs — single source of truth for tests and getRecheckUrl. */
const RECHECK_URLS = {
  production: {
    internal:
      'https://sunrun.my.salesforce.com/services/auth/link/Recheck?startURL=%2Fapex%2FRecheckVerificationConfirmation',
    community:
      'https://sunrun.my.site.com/d2hpartnercommunity/services/auth/link/Recheck?startURL=%2Fapex%2FRecheckVerificationConfirmation',
    affiliate:
      'https://sunrun.my.site.com/partners/services/auth/link/Recheck?startURL=%2Fapex%2FRecheckVerificationConfirmation',
  },
  nonProduction: {
    internal:
      'https://sunrun--uat.sandbox.my.site.com/partner/services/auth/link/Recheck?startURL=%2Fapex%2FRecheckVerificationConfirmation',
    community:
      'https://sunrun--uat.sandbox.my.site.com/d2hpartnercommunity/services/auth/link/Recheck?startURL=%2Fapex%2FRecheckVerificationConfirmation',
    affiliate:
      'https://sunrun--uat.sandbox.my.site.com/partners/services/auth/link/Recheck?startURL=%2Fapex%2FRecheckVerificationConfirmation',
  },
} as const;

const getRecheckUrl = (userProfile: UserProfile) => {
  const env = getEnvironment();
  const isFieldOrAIR = isFieldOrAIRHelper(userProfile);
  const isStreetOrFusion = isStreetOrFusionHelper(userProfile);
  const urls =
    env === 'production' ? RECHECK_URLS.production : RECHECK_URLS.nonProduction;

  if (isFieldOrAIR) {
    return urls.internal;
  }
  if (isStreetOrFusion) {
    return urls.community;
  }
  return urls.affiliate;
};

export { RECHECK_URLS, getRecheckUrl };
